<template>
  <!-- TODO: 增加一键切换到暗黑色调，类似苹果暗黑主题，并可随意切换 -->
  <div id='bd-setting'>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
      <el-tab-pane :label="profileTip" name="profile" style="height: 100%;">
        <bd-profile></bd-profile>
      </el-tab-pane>
      <el-tab-pane v-if="show" :label="codeTip" name="team" style="height: 100%;">
        <bd-code></bd-code>
      </el-tab-pane>
      <el-tab-pane v-if="show" label="我的团队" name="team" style="height: 100%;">
        <bd-team></bd-team>
      </el-tab-pane>
      <el-tab-pane label="通用设置" name="notice" style="height: 100%;">
        <bd-common></bd-common>
      </el-tab-pane>
      <el-tab-pane v-if="show" label="超级管理员" name="super" style="height: 100%;">
        <bd-super></bd-super>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BdProfile from '@/components/dashboard/setting/BdProfile'
import BdCode from '@/components/dashboard/setting/BdCode'
import BdCommon from '@/components/dashboard/setting/BdCommon'
import BdTeam from '@/components/dashboard/setting/BdTeam'
import BdSuper from '@/components/dashboard/setting/BdSuper'

export default {
  name: 'bd-setting',
  components: { BdProfile, BdCode, BdCommon, BdTeam, BdSuper },
  data () {
    return {
      activeName: 'profile',
      show: false,
    }
  },
  computed: {
    ...mapGetters([ 'showAuthority', 'isAdmin' ]),
    profileTip () {
      return this.$t('profile')
    },
    codeTip () {
      return this.$t('code')
    }
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  }
}
</script>

<style scoped>
#bd-setting {
  width: 100%;
  height: 100%;
  padding-left: 5px;
  background-color: #fafafa;
}
</style>
